import React from 'react';

const NameCard = ({ playerName }, index) => (
  <div key={index} className='NameCard'>
    {playerName}
  </div>
);

export default NameCard;
